import { render, staticRenderFns } from "./SampleSend.vue?vue&type=template&id=3242b3a8&"
import script from "./SampleSend.vue?vue&type=script&lang=js&"
export * from "./SampleSend.vue?vue&type=script&lang=js&"
import style0 from "./SampleSend.vue?vue&type=style&index=0&id=3242b3a8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports